import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XSwitch,
	XThemeContainer,
	XThemeDetailsCards,
	XThemeInputText,
	XThemeRadio,
	XThemeSwitchBtn,
	XThemeButton,
	XThemeTable,
	XThemeTag,
	XTag,
	XForm,
	XSelect,
} from '../../../../styles/GlobalThemeStyle';
import {
	Row,
	Col,
	Button,
	Input,
	notification,
	Flex,
	Space,
	Table,
	Form,
} from 'antd';
import {
	XThemeTilesCard,
	XThemeVoiceAssCard,
	XThemeVoiceaAsistCard,
	XThemeVoiceAssSeeBtn,
	XThemeVoiceAssTable,
	XThemeVoiceAssTableCard,
	XThemeVoiceAssTitle,
	XThemeVoiceCreateCaseBtn,
	XThemeVoiceaAsistChartCard,
	XThemeVoiceaAssSearchBar,
	XThemeFitToScreen,
	XThemeFixBottom,
	XThemeVoiceaAsistChatCard,
	XThemeVACheckbox,
	XThemeVASubmitBTN,
	XVSLottie,
	XVSLottieWrapper,
	XThemeVSSetViewPort,
	XThemeVSScrollContainer,
	XThemeVSGenerateAL,
	XThemeHeaderBTN,
	XThemeVSDetailsCard,
	XThemeVSPara1,
	XThemeSentToTabs,
	XThemeVARadio,
	XThemeVAInputText,
	XThemeVATextArea,
} from '../../VoiceAssistanceStyle';
import { CalendarOutlined, PlusCircleOutlined } from '@ant-design/icons';
import VSLoaderJson from '../../../../json/AppealLetter.json';
import { XRadio, XTabs } from '../../../CaseFilings/AppealLetterPreviewStyle';
import TextArea from 'antd/es/input/TextArea';
import { handleInputChange } from '../../../../utils/formFunctions';
import {
	XButtonConfirm,
	XRecommendedCard,
} from '../../../AnalyseCoverage/AnalyseCoverageStyle';
import { checkModulePermissions } from '../../../../utils/helper';
import {
	ApprovHeading,
	ResponseHeading,
	XCardBackBg,
} from '../../../CaseForm/CaseFormStyle';

const VASendAppealLetter = (props) => {
	const {
		action,
		isMdDisabled,
		isCodingDisabled,
		activeKey,
		handleTabsChange,
		appealForm,
		isAppealVerifyApproveModalOpen,
		selectMember,
		setSelectMember,
		appealLetterUsers,
		getVerifyApproveAppealLetterUserList,
		patientData,
		setFormData,
		formData,
		appealLetterLoading,
		getCodingTeamButtonFunction,
		confirmAppealLetter,
	} = props;
	return (
		<>
			<XThemeVSSetViewPort className="displyBlock">
				<XThemeVSScrollContainer>
					<Row gutter={[15, 15]}>
						<Col xs={24} className="mb-3">
							<XThemeVoiceAssTitle>
								Appeal Letter
								<br />
								<span>Send To MD Advisor Or Coding Team</span>
							</XThemeVoiceAssTitle>
						</Col>
						<Col xs={24}>
							<XThemeVoiceAssTableCard>
								<div className="hasPadding">
									{isMdDisabled && isCodingDisabled ? (
										''
									) : (
										<>
											<XTabs
												// defaultActiveKey="1"
												activeKey={activeKey}
												centered={true}
												size="large"
												type="card"
												onChange={handleTabsChange}
												items={[
													{
														label: 'Coding Team',
														key: '1',
														// disabled: isCodingDisabled,
														// disabled:
														// 	patientData?.appeal_letter_status ===
														// 		'coding_team_sent' ||
														// 	localStorage.getItem(
														// 		'role',
														// 	) === 'coding-team' ||
														// 	localStorage.getItem(
														// 		'role',
														// 	) === 'md-advisor' ||
														// 	patientData?.appeal_letter_status !==
														// 		null,
														children:
															isCodingDisabled ? (
																<></>
															) : (
																<>
																	<XForm
																		form={
																			appealForm
																		}
																		className="w-100 mt-3"
																		layout="vertical"
																		autoComplete="off"
																		onFinish={
																			isAppealVerifyApproveModalOpen[1]
																		}
																	>
																		<Row
																			gutter={[
																				15,
																				15,
																			]}
																			className="align-items-center mt-2"
																		>
																			<Col
																				xs={
																					24
																				}
																			>
																				<XForm.Item name="radio_group">
																					<XRadio.Group
																						className="w-100"
																						name="radiogroup"
																						defaultValue={
																							1
																						}
																						value={
																							selectMember
																						}
																						onChange={(
																							e,
																						) => {
																							setSelectMember(
																								e
																									.target
																									.value,
																							);
																							appealForm.setFieldValue(
																								{
																									appeal_letter_assigned_to:
																										null,
																								},
																							);
																						}}
																					>
																						<Row className="align-items-center">
																							<Col
																								xs={
																									24
																								}
																								md={
																									12
																								}
																								lg={
																									24
																								}
																								className="mb-2 md-0 lg-2"
																							>
																								<XRadio
																									className="codingTeamHorizantal"
																									value={
																										1
																									}
																								>
																									Send
																									to
																									Coding
																									Team
																								</XRadio>
																							</Col>
																							<Col
																								xs={
																									24
																								}
																								md={
																									12
																								}
																								lg={
																									24
																								}
																							>
																								<XRadio
																									className="codingTeamHorizantal"
																									value={
																										2
																									}
																								>
																									Assign
																									to
																									Coding
																									Team
																									Member
																								</XRadio>
																							</Col>
																						</Row>
																					</XRadio.Group>
																				</XForm.Item>
																			</Col>
																		</Row>

																		{selectMember ===
																			2 && (
																			<Row
																				gutter={[
																					15,
																					15,
																				]}
																				className="align-items-center"
																			>
																				<Col
																					xs={
																						24
																					}
																				>
																					<XForm.Item
																						name="appeal_letter_assigned_to"
																						label="Assign To"
																						rules={[
																							{
																								required: true,
																								message:
																									'User is required',
																							},
																						]}
																					>
																						<XSelect
																							size="large"
																							placeholder="Assign To"
																							name="appeal_letter_assigned_to"
																							allowClear
																							showSearch={
																								true
																							}
																							filterOption={(
																								input,
																								option,
																							) =>
																								option.label
																									.toLowerCase()
																									.includes(
																										input.toLowerCase(),
																									)
																							}
																							style={{
																								textAlign:
																									'left',
																							}}
																							className="demo-case-css"
																							options={
																								appealLetterUsers
																							}
																							onFocus={() => {
																								getVerifyApproveAppealLetterUserList(
																									{
																										role: isAppealVerifyApproveModalOpen[2],
																										organization_id:
																											patientData.organization,
																									},
																								);
																							}}
																							onSearch={(
																								search,
																							) => {
																								if (
																									search.length >=
																									3
																								) {
																									getVerifyApproveAppealLetterUserList(
																										{
																											role: isAppealVerifyApproveModalOpen[2],
																											search,
																											organization_id:
																												patientData.organization,
																										},
																									);
																								} else if (
																									search.length ===
																									0
																								) {
																									getVerifyApproveAppealLetterUserList(
																										{
																											role: isAppealVerifyApproveModalOpen[2],
																											organization_id:
																												patientData.organization,
																										},
																									);
																								}
																							}}
																							onChange={(
																								value,
																							) => {
																								setFormData(
																									{
																										...formData,
																										appeal_letter_assigned_to:
																											value,
																									},
																								);
																							}}
																						/>
																					</XForm.Item>
																				</Col>
																			</Row>
																		)}

																		<Row
																			gutter={[
																				15,
																				15,
																			]}
																			className="align-items-center"
																		>
																			<Col
																				xs={
																					24
																				}
																			>
																				<XForm.Item
																					name="appeal_letter_remarks"
																					label="Enter Remarks"
																					rules={[
																						{
																							required: true,
																							message:
																								'Enter Remarks',
																						},
																					]}
																				>
																					<TextArea
																						size="large"
																						style={{
																							fontSize:
																								'14px',
																						}}
																						placeholder="Enter Remarks and hit Ctrl + Enter to submit"
																						name="appeal_letter_remarks"
																						onChange={(
																							e,
																						) =>
																							handleInputChange(
																								e,
																								formData,
																								setFormData,
																							)
																						}
																						onKeyDown={(
																							e,
																						) => {
																							// Check for Cmd + Enter (Mac) or Ctrl + Enter (Windows/Linux)

																							if (
																								(e.ctrlKey ||
																									e.metaKey) &&
																								e.key ===
																									'Enter'
																							) {
																								e.preventDefault(); // Prevents adding a new line
																								document
																									.querySelector(
																										'button[type="submit"]',
																									)
																									.click(); // Programmatically trigger the submit button
																							}
																						}}
																					/>
																				</XForm.Item>
																			</Col>
																		</Row>
																		<Row
																			gutter={[
																				15,
																				15,
																			]}
																			className="align-items-center"
																		>
																			<Col
																				xs={
																					24
																				}
																			>
																				<XButtonConfirm
																					className="ms-0"
																					style={{
																						background:
																							'#007299',
																						width: '100%',
																					}}
																					loading={
																						appealLetterLoading
																					}
																					htmlType="submit"
																				>
																					Send
																				</XButtonConfirm>
																			</Col>
																		</Row>
																	</XForm>
																</>
															),
													},

													{
														label: 'MD Advisor',
														key: '2',
														children:
															isMdDisabled ? (
																<></>
															) : (
																<>
																	<XForm
																		form={
																			appealForm
																		}
																		className="w-100 mt-3"
																		layout="vertical"
																		autoComplete="off"
																		onFinish={
																			isAppealVerifyApproveModalOpen[1]
																		}
																	>
																		<Row
																			gutter={[
																				15,
																				15,
																			]}
																			className="align-items-center mt-2"
																		>
																			<Col
																				xs={
																					24
																				}
																			>
																				<XForm.Item name="radio_group">
																					<XRadio.Group
																						className="w-100"
																						name="radiogroup"
																						defaultValue={
																							1
																						}
																						onChange={(
																							e,
																						) => {
																							setSelectMember(
																								e
																									.target
																									.value,
																							);
																							appealForm.setFieldValue(
																								{
																									appeal_letter_assigned_to:
																										null,
																								},
																							);
																						}}
																					>
																						<Row className="align-items-center">
																							<Col
																								xs={
																									24
																								}
																								md={
																									12
																								}
																								lg={
																									24
																								}
																								className="mb-2 md-0 lg-2"
																							>
																								<XRadio
																									value={
																										1
																									}
																								>
																									Send
																									to
																									MD
																									Advisor
																									Team
																								</XRadio>
																							</Col>
																							<Col
																								xs={
																									24
																								}
																								md={
																									12
																								}
																								lg={
																									24
																								}
																							>
																								<XRadio
																									value={
																										2
																									}
																								>
																									Assign
																									to
																									MD
																									Advisor
																									Member
																								</XRadio>
																							</Col>
																						</Row>
																					</XRadio.Group>
																				</XForm.Item>
																			</Col>
																		</Row>

																		{selectMember ===
																			2 && (
																			<Row
																				gutter={[
																					15,
																					15,
																				]}
																				className="align-items-center"
																			>
																				<Col
																					xs={
																						24
																					}
																				>
																					<XForm.Item
																						name="appeal_letter_assigned_to"
																						label="Assign To"
																						rules={[
																							{
																								required: true,
																								message:
																									'User is required',
																							},
																						]}
																					>
																						<XSelect
																							size="large"
																							placeholder="Assign To"
																							name="appeal_letter_assigned_to"
																							allowClear
																							showSearch={
																								true
																							}
																							filterOption={(
																								input,
																								option,
																							) =>
																								option.label
																									.toLowerCase()
																									.includes(
																										input.toLowerCase(),
																									)
																							}
																							style={{
																								textAlign:
																									'left',
																							}}
																							className="demo-case-css"
																							options={
																								appealLetterUsers
																							}
																							onFocus={() => {
																								getVerifyApproveAppealLetterUserList(
																									{
																										role: isAppealVerifyApproveModalOpen[2],
																										organization_id:
																											patientData.organization,
																									},
																								);
																							}}
																							onSearch={(
																								search,
																							) => {
																								if (
																									search.length >=
																									3
																								) {
																									getVerifyApproveAppealLetterUserList(
																										{
																											role: isAppealVerifyApproveModalOpen[2],
																											search,
																											organization_id:
																												patientData.organization,
																										},
																									);
																								} else if (
																									search.length ===
																									0
																								) {
																									getVerifyApproveAppealLetterUserList(
																										{
																											role: isAppealVerifyApproveModalOpen[2],
																											organization_id:
																												patientData.organization,
																										},
																									);
																								}
																							}}
																							onChange={(
																								value,
																							) => {
																								setFormData(
																									{
																										...formData,
																										appeal_letter_assigned_to:
																											value,
																									},
																								);
																							}}
																						/>
																					</XForm.Item>
																				</Col>
																			</Row>
																		)}

																		<Row
																			gutter={[
																				15,
																				15,
																			]}
																			className="align-items-center"
																		>
																			<Col
																				xs={
																					24
																				}
																			>
																				<XForm.Item
																					name="appeal_letter_remarks"
																					label="Enter Remarks"
																					rules={[
																						{
																							required: true,
																							message:
																								'Enter Remarks',
																						},
																					]}
																				>
																					<TextArea
																						size="large"
																						style={{
																							fontSize:
																								'14px',
																						}}
																						placeholder="Enter Remarks and hit Ctrl + Enter to submit"
																						name="appeal_letter_remarks"
																						onChange={(
																							e,
																						) =>
																							handleInputChange(
																								e,
																								formData,
																								setFormData,
																							)
																						}
																						onKeyDown={(
																							e,
																						) => {
																							if (
																								(e.ctrlKey ||
																									e.metaKey) &&
																								e.key ===
																									'Enter'
																							) {
																								e.preventDefault(); // Prevents adding a new line
																								document
																									.querySelector(
																										'button[type="submit"]',
																									)
																									.click(); // Programmatically trigger the submit button
																							}
																						}}
																					/>
																				</XForm.Item>
																			</Col>
																		</Row>
																		<Row
																			gutter={[
																				15,
																				15,
																			]}
																			className="align-items-center"
																		>
																			<Col
																				xs={
																					24
																				}
																			>
																				<XButtonConfirm
																					className="ms-0"
																					style={{
																						background:
																							'#007299',
																						width: '100%',
																					}}
																					loading={
																						appealLetterLoading
																					}
																					htmlType="submit"
																				>
																					Send
																				</XButtonConfirm>
																			</Col>
																		</Row>
																	</XForm>
																</>
															),
													},
												]}
											/>
										</>
									)}
									{checkModulePermissions('appeal-letter') &&
										localStorage.getItem('role') !==
											'coding-team' &&
										localStorage.getItem('role') !==
											'md-advisor' &&
										[
											'md_advisor_sent',
											'coding_team_sent',
										].includes(
											patientData.appeal_letter_status,
										) && (
											<XRecommendedCard
												// bgColor="#ffffff"
												background="rgba(223, 235, 240, 0.5);"
												className="mt-3"
											>
												<Row
													className="align-items-center"
													style={{
														display: 'flex', // Enable flexbox
														justifyContent:
															'center', // Horizontally center
														alignItems: 'center', // Vertically center
													}}
												>
													<img
														style={{
															padding: '10px',
														}}
														src="/images/response.svg"
														alt="response"
													/>
													{patientData?.appeal_letter_status ===
														'md_advisor_sent' && (
														<ResponseHeading>
															Awaiting for MD
															advisor to respond
														</ResponseHeading>
													)}
													{patientData?.appeal_letter_status ===
														'coding_team_sent' && (
														<ResponseHeading>
															Awaiting for coding
															team to respond
														</ResponseHeading>
													)}
												</Row>
											</XRecommendedCard>
										)}
									{/* <XDivider /> */}
									<div
										style={{
											background: `${
												patientData.appeal_letter_remarks
													? '#e0e0e0'
													: ''
											}`,
											padding: '10px',
										}}
									>
										{patientData.appeal_letter_remarks ? (
											<>
												<p
													style={{
														fontWeight: 'bold',
														fontSize: '16px',
														textAlign: 'start',
													}}
												>
													Query
												</p>
												<p
													style={{
														textAlign: 'justify',
													}}
												>
													{
														patientData.appeal_letter_remarks
													}
												</p>
											</>
										) : (
											<></>
										)}
									</div>
									{/* //////////////////////// */}
									<div key="buttonsContainer">
										{patientData?.appeal_letter_status ===
										'coding_team_sent' ? (
											checkModulePermissions(
												'appeal-letter',
											).sub_modules.includes(
												'verify-coding-team',
											) ? (
												<>
													<XCardBackBg className="mt-4 align-item-center hasPadding">
														<ApprovHeading>
															Confirm and Approve
														</ApprovHeading>
														<Row
															gutter={[15, 15]}
															className="align-items-center mt-3"
														>
															<Col xs={24}>
																<XButtonConfirm
																	className="ms-0"
																	style={{
																		background:
																			'#007299',
																		color: '#fff',
																		width: '100%',
																		type: 'primary',
																		size: 'large',
																		shape: 'round',
																		borderRadius:
																			'20px',
																	}}
																	loading={
																		appealLetterLoading
																	}
																	// htmlType="submit"

																	onClick={() =>
																		getCodingTeamButtonFunction(
																			'sent_for_verification',
																			'Verified',
																			'coding_team_approved',
																		)
																	}
																>
																	Approve
																</XButtonConfirm>
															</Col>
														</Row>
													</XCardBackBg>
												</>
											) : (
												<></>
											)
										) : patientData?.appeal_letter_status ===
												'md_advisor_sent' &&
										  patientData?.case_amount >=
												patientData?.appeal_letter_approval_threshold ? (
											checkModulePermissions(
												'appeal-letter',
											).sub_modules.includes(
												'confirm-letter',
											) ? (
												<>
													<XCardBackBg className="mt-4 align-item-center hasPadding">
														<ApprovHeading>
															Confirm and Approve
														</ApprovHeading>
														<Row
															gutter={[15, 15]}
															className="align-items-center mt-3"
														>
															<Col xs={24}>
																<XButtonConfirm
																	className="ms-0"
																	style={{
																		background:
																			'#007299',
																		color: '#fff',
																		width: '100%',
																		type: 'primary',
																		size: 'large',
																		shape: 'round',
																		borderRadius:
																			'20px',
																	}}
																	loading={
																		appealLetterLoading
																	}
																	// htmlType="submit"
																	onClick={() => {
																		confirmAppealLetter(
																			'md_advisor_approved',
																		);
																	}}
																>
																	Approve
																</XButtonConfirm>
															</Col>
														</Row>
													</XCardBackBg>
												</>
											) : (
												<></>
											)
										) : patientData?.case_amount <
												patientData?.appeal_letter_approval_threshold &&
										  checkModulePermissions(
												'appeal-letter',
										  ).sub_modules.includes(
												'confirm-letter',
										  ) ? (
											<>
												<XCardBackBg className="mt-4 align-item-center hasPadding">
													<ApprovHeading>
														Confirm and Approve
													</ApprovHeading>
													<Row
														gutter={[15, 15]}
														className="align-items-center mt-3"
													>
														<Col xs={24}>
															<XButtonConfirm
																className="ms-0"
																style={{
																	background:
																		'#007299',
																	color: '#fff',
																	width: '100%',
																	type: 'primary',
																	size: 'large',
																	shape: 'round',
																	borderRadius:
																		'20px',
																}}
																loading={
																	appealLetterLoading
																}
																// htmlType="submit"
																onClick={() =>
																	confirmAppealLetter(
																		'md_advisor_approved',
																	)
																}
															>
																Approve
															</XButtonConfirm>
														</Col>
													</Row>
												</XCardBackBg>
											</>
										) : (
											<></>
										)}
									</div>
								</div>
							</XThemeVoiceAssTableCard>
						</Col>
					</Row>
				</XThemeVSScrollContainer>
			</XThemeVSSetViewPort>
		</>
	);
};

export default VASendAppealLetter;
